/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
export enum TableAvailableActionsEnum {
    EDIT = 'EDIT',
    DELETE = 'DELETE',
    VIEW = 'VIEW'
}
